import seizureSafeIcon from "../../icons/seizureSafeIcon.svg"
import adhdIcon from "../../icons/adhdIcon.svg"
import cognitiveDisabilityIcon from "../../icons/cognitiveDisabilityIcon.svg"
import lowVisionIcon from "../../icons/lowVisionIcon.svg"

export default [
    {
        label: 'Cognitive Disability',
        key: 'cognitive-disabilities-profile',
        icon: cognitiveDisabilityIcon,
    },
    {
        label: 'Low Vision',
        key: 'low-vision-profile',
        icon: lowVisionIcon,
    },
    {
        label: 'Seizure Safe',
        key: 'seizure-safe-profile',
        icon: seizureSafeIcon,
    },
    {
        label: 'ADHD',
        key: 'adhd-profile',
        icon: adhdIcon,
    },
]